import React, { useState, useEffect } from 'react';
import SaldoView from './SaldoView';
import { httpGet } from '../../http';

const Saldo = (props) => {

    const [ documentos, setDocumentos ] = useState([])
    const [ request, setRequest ] = useState({
        loading: false,
        error: false,
        errorMsg: ''
    });

    useEffect(() => {
        console.log('FACTURA', props.history.location.state.factura);
        getSaldo();
    }, []);

    const getSaldo = async () => {
        try {
            
            setRequest({
                ...request,
                loading: true,
                error: false,
                errorMsg: ''
            });

            let docRowid = props.history.location.state.factura.docRowid;
            if(docRowid == "0"){
                docRowid = props.history.location.state.factura.rowidDocto;
            }

            const resp = await httpGet('/api/v1/egresos/detalle-saldo/' + docRowid);
            console.log('URL', '/api/v1/egresos/detalle-saldo/' + docRowid);
            setDocumentos(resp.data);
            console.log('documentos', resp.data);
            setRequest({
                ...request,
                loading: false,
                error: false,
                errorMsg: ''
            });
        }catch (error) {
            setRequest({
                ...request,
                loading: false,
                error: true,
                errorMsg: error.message
            });
        }
    }

    return (
        <div>
            <SaldoView request={request} documentos={documentos} />
        </div>
    );
}

export default Saldo;